import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StateCacheService } from './../../../core/services/state-cache.service';
import { ScheduleCalendarComponent } from './schedule-calendar/schedule-calendar.component';
import { TaskCalendarComponent } from './task-calendar/task-calendar.component';
//import { TutorialService } from 'src/app/core/tutorial/tutorial.service';
import { TutorialSection } from 'src/app/core/tutorial/tutorial.models';
import { CALENDAR_TOOLTIPS } from './calendar-tooltips';

@Component({
  selector: 'app-schedule-view',
  templateUrl: './schedule-view.component.html',
  styleUrls: ['./schedule-view.component.scss'],
  // The appointment list and tasks tabs use these too; the calendar sets the same itself.
  providers: [CALENDAR_TOOLTIPS],
})
export class ScheduleViewComponent implements OnInit, OnDestroy {

  @ViewChild('calendar') calendarComponent?: ScheduleCalendarComponent;
  @ViewChild('tasks') tasksComponent?: TaskCalendarComponent;
  selectedTabId: number = 0;

  constructor(private stateCache: StateCacheService, //private tutorialService: TutorialService
  ) { }

  ngOnInit(): void {
    const currentTab = this.stateCache.get<number>('calendarTab')! || 0;
    this.selectedTabId = currentTab;
}


  ngOnDestroy(): void {
    //this.tutorialService.closeTutorial();
    this.stateCache.set('calendarTab', this.selectedTabId);
  }

  onTabChange(index: number): void {
    // The calendar's open day stays open, so it is still there on coming back.
    if (index !== 2 && this.tasksComponent) {
      this.tasksComponent.resetOpenRows();
    }
    this.selectedTabId = index;
    this.stateCache.set('calendarTab', index);
  }

}
